import React, { PureComponent } from 'react';
import axios from 'axios';
import Layout from '../components/complex/layout';
import SectionsList from './sections/sectionsList';
import appConstant from '../../constants/app';
import ModalComponent from '../components/complex/modalComponent';
import NewSectionForm from './sections/newSectionForm';
import EditSectionForm from './sections/editSectionForm';
import HideSectionForm from './sections/hideSectionForm';
import DeleteSectionForm from './sections/deleteSectionForm';
import GroupsSection from './sections/groupsSection';
import NewGroupForm from './sections/groupsSection/newGroupForm';
import EditGroupForm from './sections/groupsSection/editGroupForm';
import HideGroupForm from './sections/groupsSection/hideGroupForm';
import DeleteGroupForm from './sections/groupsSection/deleteGroupForm';
import actionsConstant from '../../constants/actions';

const token = localStorage.getItem('token');

class Sections extends PureComponent {
  onToggleModal = () => {
    this.setState(prevState => ({ isActive: !prevState.isActive }));
  }

  onSectionsListRender = () => {
    this.fetch();
  }

  state = {
    isSectionsList: true,
    id: null,
    groupId: null,
    items: [],
    groupItems: [],
    contentSections: [],
    titleSection: '',
    isActive: false,
    title: 'Add section',
    body: <NewSectionForm
      onClose={this.onToggleModal}
      onAccept={this.onSectionsListRender}
    />,
  }

  fetch = () => {
    let url = `${appConstant.API_URL}/section?access_token=${token}`;
    axios.get(url)
      .then(res => {
        const contentSections = res.data;
        this.onChangeSectionsList(contentSections.sections);
        this.setState({ contentSections });
      }).catch(err => {
        console.log(err);
      });
  }

  componentDidMount () {
    this.fetch();
  }

  fetchGroupsBySection = (sectionId) => {
    let url = `${appConstant.API_URL}/section?parent_id=${sectionId}&access_token=${token}`;
    axios.get(url)
      .then(res => {
        const contentGroups = res.data;

        this.onChangeGroupsList(contentGroups.sections);
      }).catch(err => {
        console.log(err);
      });
  }

  onHandleModal = (id, label, hidden, action) => {
    this.setState({
      id,
      titleSection: label,
    });

    if (action !== actionsConstant.detail) {
      this.onToggleModal();
    }
    
    if(action === actionsConstant.edit) {
      this.setState({
        body: <EditSectionForm
          sectionId={id}
          onClose={this.onToggleModal}
          onAccept={this.onSectionsListRender}
        />,
        title: 'Edit section',
      });
    } else if(action === actionsConstant.hide) {
      this.setState({
        body: <HideSectionForm
          sectionId={id}
          label={label}
          hidden={hidden}
          onClose={this.onToggleModal}
          onAccept={this.onSectionsListRender}
        />,
        title: `Are you sure you want to ${hidden === 0 ? 'hide' : 'show' } ${label}?`,
      });
    } else if(action === actionsConstant.delete) {
      this.setState({
        body: <DeleteSectionForm
          sectionId={id}
          label={label}
          onClose={this.onToggleModal}
          onAccept={this.onSectionsListRender}
        />,
        title: `Are you sure you want to delete ${label}?`,
      });
    } else if(action === actionsConstant.detail) {
      this.setState({
        isSectionsList: false,
      });

      this.fetchGroupsBySection(id);
    }
  }
  
  onHandleGroupModal = (id, label, hidden, action) => {
    this.setState({groupId: id});

    if (action !== actionsConstant.detail) {
      this.onToggleModal();
    }

    if(action === actionsConstant.edit) {
      this.setState({
        body: <EditGroupForm
          groupId={id}
          onClose={this.onToggleModal}
          onAccept={this.fetchGroupsBySection}
        />,
        title: 'Edit group',
      });
    } else if(action === actionsConstant.hide) {
      this.setState({
        body: <HideGroupForm
          groupId={id}
          label={label}
          hidden={hidden}
          onClose={this.onToggleModal}
          onAccept={this.fetchGroupsBySection}
        />,
        title: `Are you sure you want to ${hidden === 0 ? 'hide' : 'show' } ${label}?`,
      });
    } else if(action === actionsConstant.delete) {
      this.setState({
        body: <DeleteGroupForm
          groupId={id}
          label={label}
          onClose={this.onToggleModal}
          onAccept={this.fetchGroupsBySection}
          sectionId={this.state.id}
        />,
        title: `Are you sure you want to delete ${label}?`,
      });
    }
  }
  
  addLink = () => {
    this.onToggleModal();

    this.setState({
      title: 'Add section',
      body: <NewSectionForm
        onClose={this.onToggleModal}
        onAccept={this.onSectionsListRender}
      />,
    });
  }

  addGroup = () => {
    this.onToggleModal();

    this.setState({
      title: 'Add group',
      body: <NewGroupForm
        onAccept={this.fetchGroupsBySection}
        onClose={this.onToggleModal}
        sectionId={this.state.id}
      />,
    });
  }

  onChangeGroupsList = (list) => {
    this.setState({
      groupItems: list,
    });
  }
  
  onChangeSectionsList = (list) => {
    this.setState({
      items: list,
    })
  };

  backToSectionsListView = () => {
    this.setState({
      isSectionsList: true,
    });
  }

  cancelGroupLinksEdit = (sectionId) => {
    this.fetchGroupsBySection(sectionId);
  }
  
  render() {
    const {
      isSectionsList,
      items,
      groupItems,
      isActive,
      title,
      body,
      titleSection,
    } = this.state;

    return (
      <Layout>
        {
          isSectionsList ?
          <SectionsList
            items={items}
            onChangeSectionsList={this.onChangeSectionsList}
            showModalHandle={this.onHandleModal}
            addLink={this.addLink}
          />
          :
          <GroupsSection
            items={groupItems}
            onChangeGroupsList={this.onChangeGroupsList}
            showModalHandle={this.onHandleGroupModal}
            addGroup={this.addGroup}
            titleSection={titleSection}
            showSectionsList={this.backToSectionsListView}
            onClickCancelEdit={this.fetchGroupsBySection}
          />
        }
        <ModalComponent
          isActive={isActive}
          onClose={this.onToggleModal}
          title={title}
          body={body}
        />
      </Layout>
    );
  }
}

export default Sections;


// WEBPACK FOOTER //
// ./src/app/screens/sections.js